export const capitalizeFirst = (s?: string | null) => {
    if (s == undefined || s == null) return ""
    return s.charAt(0).toUpperCase() + s.slice(1);
}